import {
    CUSTOMER_TOKEN_START,
    CUSTOMER_TOKEN_SUCCESS,
    CUSTOMER_TOKEN_ERROR,
  } from "Constant/RentalCustomer";
  
const initialState = {
    loading: false,
    data: [],
};
  
export default function customerToeknReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
      case CUSTOMER_TOKEN_START:
        return {
          ...state,
          loading: true,
        };
      case CUSTOMER_TOKEN_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case CUSTOMER_TOKEN_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
}
  